import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Badge, Button} from 'reactstrap';
import {Link} from "react-router-dom"
import {_changeAfiliiateStatus, _getUserAffiliateStatistics} from "../../../../../services/apis/AdminAffiliate"
import AffiliateStatisticCollapse from "./AffiliateStatisticCollapse"

class ItemUser extends Component {
    state = {
        isChangeAffiliateStatus: false,
        affiliateData: {
            clicks: 0,
            conversions: 0,
            earned: 0,
            paid: 0,
            pending: 0,
        },
        error: '',
        isCollapseOpen: false,
    }


    componentDidMount() {
        this._fetchUserAffiliateStatistics();
    }

    componentDidUpdate(prevProps){
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)){
            this._fetchUserAffiliateStatistics();
        }
    }

    _fetchUserAffiliateStatistics = () =>{
        _getUserAffiliateStatistics(this.props.user.owner._id)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        affiliateData: {
                            ...prevState.affiliateData,
                            ...result.data,
                        }
                    }))

                }
            })
    }


    _toggleStatus = (e) => {
        const {user} = this.props;
        const currentStatus = user.status || 'active';
        const changedStatus = currentStatus === 'active' ? 'blocked' : 'active';

        e.stopPropagation()
        this.setState({
            isChangeAffiliateStatus: true,
        })
        _changeAfiliiateStatus(changedStatus, user.owner._id)
            .then(result => {
                if (result.success) {
                    this.props.onRefreshPage();
                } else {
                    console.log(result.message)
                }
                this.setState({
                    isChangeAffiliateStatus: false,
                })
            })
    }

    _handleTransfersToAcc = (e, user)=>{
        this.props.transfersToAcc(user)
        this.props.toggleWithdrawal();
        e.stopPropagation();
    }


    _toggleCollapse = () => {
        this.setState(prevState => ({
            isCollapseOpen: !prevState.isCollapseOpen,
        }))
    }




    render() {
        const {user} = this.props;
        const {isChangeAffiliateStatus, isCollapseOpen, affiliateData} = this.state;
        const badgeColorMap = {
            active: "success",
            blocked: "danger",
        }
        return (
            <div className='ItemUser' onClick={this._toggleCollapse}>
                <div className='row table-row'>
                    <div className='col-2'><Link to={'/a/users/'.concat(user.owner._id)}> {user.owner.name}</Link></div>
                    <div className='col-3'>{user.owner.email}</div>
                    <div className='col-1'>
                        <Badge color={badgeColorMap[user.status]}
                               className={isChangeAffiliateStatus ? 'disabled' : ''}
                               onClick={(e)=>this._toggleStatus(e)} pill>{user.status}
                        </Badge>
                    </div>
                    <div className='col-3'>{user.paypal}</div>
                    <div className='col-1'>{'$' + user.balance}</div>
                    <div className='col-2'>
                        <Button
                            color="primary"
                            onClick={(e)=> this._handleTransfersToAcc(e, user)}
                            disabled={user.balance <= 0}
                        >Transfers</Button>
                    </div>

                    <AffiliateStatisticCollapse
                        isOpen={isCollapseOpen}
                        toggleCollapse={this._toggleCollapse}
                        affiliateStatisticData={affiliateData}
                    />

                </div>
            </div>
        );
    }
}

ItemUser.propTypes = {
    user: propTypes.object.isRequired,
    transfersToAcc: propTypes.func.isRequired,
    toggleWithdrawal: propTypes.func.isRequired,
    onRefreshPage: propTypes.func.isRequired,
}

export default ItemUser;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/users/ItemUser.js